import React from "react";

// TIP-504 — payment-endorsement summary on the (dark navy) profile banner.
// Driven by the two-way-gated view endpoint (TIP-492):
//   mode "member" -> gold "verified" chip with the real count
//   mode "prompt" -> locked upsell, NO count ("Become a member to view…")
//   anything else -> nothing (e.g. target company isn't a member, or zero)

const CheckIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M3 8.5L6.5 12L13 4.5" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const LockIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <rect x="3" y="7" width="10" height="7" rx="1.6" stroke="currentColor" strokeWidth="1.5" />
    <path d="M5.5 7V5.2a2.5 2.5 0 015 0V7" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const EndorsementsBadge = ({ mode, count = 0 }) => {
  if (mode === "member") {
    if (!count) return null;
    const noun = count === 1 ? "endorsement" : "endorsements";
    return (
      <div className="inline-flex items-center gap-2.5 py-1 pl-1 pr-4 rounded-full bg-white/10 border border-white/15">
        <span className="flex items-center justify-center w-7 h-7 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#9A7B14] shadow-sm">
          <CheckIcon className="w-4 h-4 text-white" />
        </span>
        <span className="flex flex-col leading-tight text-left">
          <span className="text-white font-semibold text-f14">{count} payment {noun}</span>
          <span className="hidden sm:block text-white/55 text-[11px]">Pays-on-time feedback</span>
        </span>
      </div>
    );
  }

  if (mode === "prompt") {
    // Non-member viewer of a member company — upsell ONLY, no count.
    return (
      <div className="inline-flex items-center gap-2.5">
        <span className="flex items-center justify-center w-7 h-7 rounded-full bg-white/10 shrink-0">
          <LockIcon className="w-3.5 h-3.5 text-[#FFC36B]" />
        </span>
        <span className="text-[#FFC36B] font-semibold text-f13 sm:text-f14 leading-tight text-left">
          Become a member to view payment endorsements
        </span>
      </div>
    );
  }

  return null;
};

export default EndorsementsBadge;
